import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import './HomePage.css';
import './DetailPage.css';
import MovieCard from '../components/MovieCard';
import axios from 'axios';
import { CARD_STEP, getCardsPerScroll } from '../utils/carousel';

const DetailPage = () => {
  const [recommendedMovies, setRecommendedMovies] = useState([]);
  const { movieid } = useParams();
  const [movie, setMovie] = useState();

  useEffect(() => {
    if (movieid) {
      axios.get(`/api/movies/${movieid}`)
        .then((response) => {
          setMovie(response.data);
        })
        .catch((error) => {
          console.error("Error fetching movie details", error);
        });
    }
  }, [movieid]);

  useEffect(() => {
    const fetchRecommendedMovies = async () => {
      if (movieid) {
        try {
          const response = await fetch('/api/movies/similarmovie?movieid=' + movieid, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({}),
          });
          const data = await response.json();
          setRecommendedMovies(data.recommendations);
        }
        catch (error) {
          console.error('Error fetching recommended movies', error);
        }
      }
    };

    fetchRecommendedMovies();
  }, [movieid]);

  const scroll = (direction) => {
    const element = document.getElementById('grid-recommended');
    if (element) {
      if (direction === 'left') {
        element.scrollLeft = 0;
      } else {
        element.scrollLeft += CARD_STEP * getCardsPerScroll();
      }
    }
  };

  if (!movie) {
    return <p className="page-loading">Loading...</p>;
  }

  const genreList = movie.genres
    ? movie.genres.split(',').map((g) => g.trim()).filter(Boolean)
    : [];

  return (
    <>
      <div
        className="detail-hero"
        style={{
          backgroundImage: `linear-gradient(180deg, rgba(9,11,18,0.25) 0%, rgba(9,11,18,0.8) 65%, var(--bg) 100%), url(${movie.backdrop_path})`,
        }}
      >
        <div className="detail-hero-content">
          <img src={movie.poster_path} alt={movie.title} className="detail-poster" />
          <div className="detail-info">
            <h1 className="detail-title">{movie.title}</h1>
            {movie.tagline && <p className="detail-tagline">{movie.tagline}</p>}

            <div className="detail-meta">
              {movie.vote_average != null && (
                <span className="detail-meta-item detail-rating">
                  <i className="fa-solid fa-star"></i> {Number(movie.vote_average).toFixed(1)}
                </span>
              )}
              {movie.release_date && <span className="detail-meta-item">{movie.release_date}</span>}
              {movie.runtime ? <span className="detail-meta-item">{movie.runtime} min</span> : null}
              {movie.original_language && (
                <span className="detail-meta-item">{movie.original_language.toUpperCase()}</span>
              )}
            </div>

            {genreList.length > 0 && (
              <div className="detail-genres">
                {genreList.map((genre) => (
                  <span key={genre} className="detail-genre-pill">{genre}</span>
                ))}
              </div>
            )}

            <p className="detail-overview">{movie.overview}</p>

            <div className="detail-cast-director">
              {movie.director && <p><span>Director</span>{movie.director}</p>}
              {movie.movie_cast && <p><span>Cast</span>{movie.movie_cast}</p>}
            </div>

            <div className="detail-actions">
              {movie.homepage && (
                <a href={movie.homepage} className="detail-button primary" target="_blank" rel="noopener noreferrer">
                  <i className="fa-solid fa-globe"></i> Website
                </a>
              )}
              {movie.imdb_id && (
                <a
                  href={`https://www.imdb.com/title/${movie.imdb_id}`}
                  className="detail-button"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="fa-brands fa-imdb"></i> IMDB
                </a>
              )}
            </div>
          </div>

          <aside className="detail-sidebar">
            <div className="detail-stat">
              <span className="detail-stat-label">Budget</span>
              <span className="detail-stat-value">${movie.budget?.toLocaleString()}</span>
            </div>
            <div className="detail-stat">
              <span className="detail-stat-label">Revenue</span>
              <span className="detail-stat-value">${movie.revenue?.toLocaleString()}</span>
            </div>
            <div className="detail-stat">
              <span className="detail-stat-label">Vote Average</span>
              <span className="detail-stat-value">{movie.vote_average}</span>
            </div>
            <div className="detail-stat">
              <span className="detail-stat-label">Vote Count</span>
              <span className="detail-stat-value">{movie.vote_count}</span>
            </div>
            <div className="detail-stat">
              <span className="detail-stat-label">Languages</span>
              <span className="detail-stat-value">{movie.spoken_languages}</span>
            </div>
          </aside>
        </div>
      </div>

      {movie.keywords && (
        <div className="detail-stats">
          <div className="detail-keywords">
            <span className="detail-stat-label">Keywords</span>
            <p>{movie.keywords}</p>
          </div>
        </div>
      )}

      {recommendedMovies.length > 0 && (
        <div className="home-page detail-recommended">
          <div className="genre-section">
            <h1>Similar Movies</h1>
            <div className="movie-grid-wrapper">
              <button className="arrow arrow-left" onClick={() => scroll('left')}>&lt;</button>
              <div className="movie-grid" id="grid-recommended">
                {recommendedMovies.map((movie, index) => (
                  <MovieCard key={index} movie={movie} />
                ))}
              </div>
              <button className="arrow arrow-right" onClick={() => scroll('right')}>&gt;</button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default DetailPage;
